import moment from "moment";

export default function formatDate(value, fallback = '', format = 'DD/MM/YYYY') {
    if (value) {
        return moment(String(value)).format(format)
    } else if (typeof fallback !== "undefined") {
        return fallback
    }
}
